import { useSelector } from "react-redux";
import { State } from "../../../../reducers";
import { CreditoFiscalResumen } from "./contents/CreditoFiscalResumen";
import { NotaCreditoResumen } from "./contents/NotaCreditoResument";

const RenderDoc = (props: any) => {
  switch (props.idDoc) {
    case '03':
      return <CreditoFiscalResumen />;
    case '05':
      return <NotaCreditoResumen />;
    default:
      return <div></div>;
  }
};

const DynamicResumenContent = () => {
  const {activeDoc} = useSelector((state: State) => state.documentos)
  return (
    <RenderDoc idDoc={activeDoc.idDoc} />
  )
}

export default DynamicResumenContent;